import * as React from 'react'
import { DialogPopup } from '../../components/DialogPopup'
import { Grid, InputBase, Tab, Tabs, Typography } from '@material-ui/core'
import useStyles from 'src/app/maintenance/assets/styles'
import { useState } from 'react'
import { saveToken, updateToken } from '../../components/apiHelper'
import { DropDown } from '../../components/DropDown'
import Cookies from "js-cookie"
import { hasUserPermission } from 'src/app/permission'

const authTypes = [
    { label: "Key", value: "key" },
    { label: "Token", value: "token" }
]

const addTo = [
    { label: "Header", value: "header" },
    { label: "Body", value: "body" },
    { label: "Query", value: "query" }
]

export const AddAuthenticationToken = (props) => {
    const classes = useStyles()
    const [activeTab, setActiveTab] = useState(props.showTabs ? "add" : "add");
    const [newToken, setNewToken] = useState({ name: "", tokenType: "token", token: "", tempKey: "", placement: "" })
    const [editToken, setEditToken] = useState({ id: "", name: "", tokenType: "", token: "", tempKey: "", placement: "" })
    const [tokenError, setTokenError] = useState({
        nameError: null,
        tokenError: null,
        tokenTypeError: null,
        placementError: null,
        tempKeyError: null,
    })

    const handleAddToken = () => {
        props.setIsTokenDialog(prev => !prev);
        setTokenError((prev) => ({
            ...prev,
            nameError: null,
            tempKeyError: null,
            tokenTypeError: null,
            tokenError: null,
            placementError: null
        }))
        if(props.isTokenDialog == true){
            setNewToken({ name: "", token: "", tokenType: "token", placement: "", tempKey: "" })
        }
        setActiveTab("add")
    }

    const handleSaveToken = async () => {
        props.setLoading(true)
        let currentToken = activeTab === 'add' ? {...newToken} : {...editToken};

        const payload = {
            name: currentToken.name.trim(),
            tokenType: currentToken.tokenType.trim(),
            placement: currentToken.placement.trim(),
            referenceId: Cookies.get('ACCOUNT'),
            token: currentToken.tokenType === "key" 
                ? JSON.stringify({
                    key: currentToken.tempKey.trim(),
                    value: currentToken.token.trim()
                  })
                : JSON.stringify({
                    value: currentToken.token.trim()
                  })
        };
        const error = tokenValidate(payload);

        if (Object.keys(error).length > 0) {
            setTokenError(error);
            props.setLoading(false);
            return;
        }
        try {
            const response = activeTab === "add" ? await saveToken(payload) : await updateToken(payload, editToken.id);
            if(response){
                props.setToasterMessage(activeTab === 'add' 
                ? 'Authentication Token Added Successfully' 
                : 'Authentication Token Updated Successfully');
                props.setIsToasterOpen(true)
                props.setReqSuccess(true)
                if (activeTab === 'add') {
                    setNewToken({ name: "", token: "token", tokenType: "", placement: "", tempKey: "" });
                } else {
                    setEditToken({ id:"", name: "", token: "", tokenType: "", placement: "", tempKey: "" });
                }
            }
            setActiveTab("add");
            props.setIsTokenDialog(false);
            props.getToken()
            setTokenError((prev) => ({
                ...prev,
                nameError: null,
                tempKeyError: null,
                tokenTypeError: null,
                tokenError: null,
                placementError: null
            }))
        } catch (error) {
            props.setToasterMessage(error.message)
            props.setIsToasterOpen(true)
            props.setReqSuccess(false)
        } finally {
            props.setLoading(false)
            setTimeout(() =>{
                props.setIsToasterOpen(false)
            },2500)
        }
    }

    const handleTabClick = (tab) => {
        if (!props.showTabs) return;
        if (tab === "edit") {
            setEditToken({ id: "", name: "", tokenType: "", token: "", tempKey: "", placement: "" });
        } else {
            setNewToken({ name: "", tokenType: "token", token: "", tempKey: "", placement: "" });
        }
        setActiveTab(tab);
        setTokenError((prev) => ({
            ...prev,
            nameError: null,
            tempKeyError: null,
            tokenTypeError: null,
            tokenError: null,
            placementError: null
        }))
    };

    const getAuthTypeLabel = () => {
        const selectedItem = authTypes.find(item => item.value === newToken.tokenType);
        if (selectedItem) {
            return selectedItem.label;
        }
        return "";
    };

    const handleAuthTypeClick = (selectedLabel: string) => {
        const selectedItem = authTypes.find(item => item.label === selectedLabel);
        if (selectedItem) {
            handleToken("tokenType", selectedItem.value, "add");
        } else {
            handleToken("tokenType", "", "add");
        }
    };

    const handleTokenNameClick = (selectedName: string) => {
        const selectedToken = props.existTokens.find(token => token.name === selectedName);
        if (selectedToken) {
            let tokenValue = selectedToken.token;
            let keyValue = "";
            
            try {
                const parsedToken = JSON.parse(selectedToken.token);
                tokenValue = parsedToken.value || selectedToken.token;
                keyValue = parsedToken.key || "";
            } catch (e) {
                console.log("Error parsing token:", e);
                tokenValue = selectedToken.token;
            }
            setEditToken({
                id: selectedToken.id,
                name: selectedToken.name,
                tokenType: selectedToken.tokenType,
                token: tokenValue,
                placement: selectedToken.placement,
                tempKey: keyValue
            });
            setTokenError(prev => ({
            ...prev,
            nameError: null,
            tokenTypeError: null,
            placementError: null,
            tempKeyError: null,
            tokenError: null
        }));
        }
    };

    const tokenValidate = (tokenToValidate) => {
        let error: any = {}
        if (tokenToValidate.name.trim() == "") {
            error.nameError = "Name is required."
        } else if (activeTab === 'add' && props.existTokens.some(t => t.name.toLowerCase() === tokenToValidate.name.toLowerCase())) {
            error.nameError = "The Token Name Already Exists."
        }
        try {
            const tokenObj = JSON.parse(tokenToValidate.token);
            if (!tokenObj.value) {
                error.tokenError = "Value is required";
            }
            if (tokenToValidate.tokenType === "key" && !tokenObj.key) {
                error.tempKeyError = "Key is required";
            }
        } catch (e) {
            error.tokenError = "Invalid token format";
        }
        if (tokenToValidate.placement == "") {
            error.placementError = "Selecting the Token/Key placement required"
        }
        return error
    }

    const handleToken = (type, value, mode) => {
        if (mode === 'add') {
            setNewToken(prev => ({ ...prev, [type]: value }));
        } else {
            setEditToken(prev => ({ ...prev, [type]: value }));
        }
        
        setTokenError(prev => ({ ...prev, [`${type}Error`]: null }));
    };

    const getTokenValue = (token) => {
        try {
            const parsed = JSON.parse(token);
            return parsed.value || token;
        } catch {
            return token;
        }
    };
    // console.log(props.existTokens)
    return (
        <DialogPopup
            open={props.isTokenDialog}
            title="authentication Settings"
            onClose={handleAddToken}
            buttonRequired={true}
            cancel= 'cancel'
            submit={!props.showTabs || activeTab === "add" ? 'Save' : 'Update'}
            submitButtonColor='#005B96'
            disabled={activeTab === "add" && !hasUserPermission("KNOWLEDGE_BASE_UPLOADS.API_INPUT.AUTH_SETTINGS", "ADD") ||
                activeTab === "edit" && !hasUserPermission("KNOWLEDGE_BASE_UPLOADS.API_INPUT.AUTH_SETTINGS", "EDIT")
            }
            dialogContent={
                <Grid container>
                    {props.showTabs && (
                        <Grid item xs={12} md={9} className={classes.dashboardContainer} style={{marginBottom: "10px"}}>
                            <Grid item onClick={() => handleTabClick("add")} className={`${classes.tabItem} ${activeTab === "add" ? classes.active : ""}`}>
                                <h5>New Authentication</h5>
                            </Grid>

                            <Grid item 
                                onClick={() => handleTabClick("edit")} 
                                className={`${classes.tabItem} ${activeTab === "edit" ? classes.active : ""}`}                    
                            >
                                <h5>Edit Authentication</h5>
                            </Grid>
                        </Grid>
                    )}
                    {(!props.showTabs || activeTab === "add") && (
                        <>
                            <Grid container>
                                <Typography>
                                    Name
                                </Typography>
                                <InputBase
                                    className={classes.formInput}
                                    placeholder="Enter name here"
                                    value={newToken.name}
                                    onChange={(e) => handleToken('name', e.target.value, "add")}
                                />
                                {activeTab === "add" && tokenError.nameError &&
                                    <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                        {tokenError.nameError}
                                    </Typography>
                                }
                            </Grid>
                            <Grid container style={{ marginTop: '15px' }}>
                                <Typography>
                                    Authentication Type
                                </Typography>
                                <DropDown 
                                    options={authTypes.map((item) => item.label)}
                                    type="tokenType"
                                    value={getAuthTypeLabel()}
                                    onClick={handleAuthTypeClick}
                                    emptyTag="Select Token Type"
                                    isSingle={true}
                                />
                            </Grid>
                            {newToken.tokenType == "key" && (
                                <>
                                    <Grid container style={{ marginTop: '15px' }}>
                                        <Typography>
                                            Key
                                        </Typography>
                                        <InputBase
                                            className={classes.formInput}
                                            placeholder="Enter key here"
                                            value={newToken.tempKey}
                                            onChange={(e) => handleToken('tempKey', e.target.value, "add")}
                                        />
                                        {activeTab === "add" && tokenError.tempKeyError &&
                                            <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                                {tokenError.tempKeyError}
                                            </Typography>
                                        }
                                    </Grid>
                                    <Grid container style={{ marginTop: '15px' }}>
                                        <Typography>
                                            Value
                                        </Typography>
                                        <InputBase
                                            className={classes.formInput}
                                            placeholder="Enter value here"
                                            value={getTokenValue(newToken.token)}
                                            onChange={(e) => handleToken('token', e.target.value, "add")}
                                        />
                                        {activeTab === "add" && tokenError.tokenError &&
                                            <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                                {tokenError.tokenError}
                                            </Typography>
                                        }
                                    </Grid>
                                </>                      
                            )}
                            {newToken.tokenType == "token" && (
                                <>
                                    <Grid container style={{ marginTop: '15px' }}>
                                        <Typography>
                                            Value
                                        </Typography>
                                        <InputBase
                                            className={classes.formInput}
                                            placeholder="Enter value here"
                                            value={getTokenValue(newToken.token)}
                                            onChange={(e) => handleToken('token', e.target.value, "add")}
                                        />
                                        {activeTab === "add" && tokenError.tokenError &&
                                            <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                                {tokenError.tokenError}
                                            </Typography>
                                        }
                                    </Grid>
                                </>                      
                            )}

                            <Grid container style={{ marginTop: '15px' }}>
                                <Typography>
                                    Add To
                                </Typography>
                                <DropDown 
                                    options={addTo.map((item) => item.label)}
                                    type="placement"
                                    value={newToken.placement}
                                    onClick={(e) => handleToken('placement', e, "add")}
                                    emptyTag="Select add to"
                                    isSingle={true}
                                />
                                {activeTab === "add" && tokenError.placementError &&
                                    <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                        {tokenError.placementError}
                                    </Typography>
                                }
                            </Grid>
                        </>
                    )}
                    {props.showTabs && activeTab === "edit" && (
                        <>
                            <Grid container style={{ marginTop: '15px' }}>
                                    <Typography>
                                        Name
                                    </Typography>
                                    <DropDown 
                                        options={props.existTokens.map((item) => item.name)}
                                        type="tokenName"
                                        value={editToken.name}
                                        onClick={handleTokenNameClick}
                                        emptyTag="Select name"
                                        isSingle={true}
                                    />
                                    {activeTab === "edit" && tokenError.nameError &&
                                        <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                            {tokenError.nameError}
                                        </Typography>
                                    }
                            </Grid>
                            <Grid container style={{ marginTop: '15px' }}>
                                <Typography>
                                    Authentication Type
                                </Typography>
                                <InputBase
                                    className={classes.formInput}
                                    value={editToken.tokenType === "key" ? "Key" : "Token"}
                                    disabled
                                />
                            </Grid>
                            {editToken.tokenType == "key" && (
                                <>
                                    <Grid container style={{ marginTop: '15px' }}>
                                        <Typography>
                                            Key
                                        </Typography>
                                        <InputBase
                                            className={classes.formInput}
                                            placeholder="Enter key here"
                                            value={editToken.tempKey}
                                            onChange={(e) => handleToken('tempKey', e.target.value, "edit")}
                                        />
                                        {activeTab === "edit" && tokenError.tempKeyError &&
                                            <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                                {tokenError.tempKeyError}
                                            </Typography>
                                        }
                                    </Grid>
                                    <Grid container style={{ marginTop: '15px' }}>
                                        <Typography>
                                            Value
                                        </Typography>
                                        <InputBase
                                            className={classes.formInput}
                                            placeholder="Enter value here"
                                            value={getTokenValue(editToken.token)}
                                            onChange={(e) => handleToken('token', e.target.value, "edit")}
                                        />
                                        {activeTab === "edit" && tokenError.tokenError &&
                                            <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                                {tokenError.tokenError}
                                            </Typography>
                                        }
                                    </Grid>
                                </>                      
                            )}
                            {editToken.tokenType == "token" && (
                                <>
                                    <Grid container style={{ marginTop: '15px' }}>
                                        <Typography>
                                            Value
                                        </Typography>
                                        <InputBase
                                            className={classes.formInput}
                                            placeholder="Enter value here"
                                            value={getTokenValue(editToken.token)}
                                            onChange={(e) => handleToken('token', e.target.value, "edit")}
                                        />
                                        {activeTab === "edit" && tokenError.tokenError &&
                                            <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                                {tokenError.tokenError}
                                            </Typography>
                                        }
                                    </Grid>
                                </>                      
                            )}

                            <Grid container style={{ marginTop: '15px' }}>
                                <Typography>
                                    Add To
                                </Typography>
                                <InputBase
                                    className={classes.formInput}
                                    value={editToken.placement}
                                    disabled
                                />
                                {activeTab === "edit" && tokenError.placementError &&
                                    <Typography className={classes.errorText} style={{ textAlign: 'left' }}>
                                        {tokenError.placementError}
                                    </Typography>
                                }
                            </Grid>
                        </>
                    )}
                </Grid>
            }
            onSubmit={handleSaveToken}
        />
    )
}